
import { A2AMessage } from '../types';
import { messageBus } from './core/MessageBus';
import { signMessage, getLocalKeyId } from '@/hooks/a2a/useA2AKeys';
import { supabase } from '@/integrations/supabase/client';

export async function publishMessage(message: Omit<A2AMessage, 'id' | 'timestamp'>): Promise<A2AMessage> {
  const id = `msg-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
  const timestamp = new Date();
  const keyId = getLocalKeyId();

  // Get current user session
  const { data: { session } } = await supabase.auth.getSession();
  const userId = session?.user?.id;
  
  // Create the message body that will be signed
  const bodyToSign = JSON.stringify({
    id, timestamp, fromAgent: message.fromAgent, toAgent: message.toAgent, 
    content: message.content, metadata: message.metadata
  });
  
  // Sign the message body
  const signature = await signMessage(bodyToSign);
  
  // Log the interaction in the database before publishing
  try {
    await supabase.from('agent_interactions').insert({
      message_id: id,
      agent_id: message.toAgent,
      from_agent: message.fromAgent,
      to_agent: message.toAgent,
      message_type: message.metadata?.messageType || 'REQUEST',
      content: message.content,
      task_id: message.metadata?.taskId,
      model_used: message.metadata?.model,
      metadata: message.metadata,
      user_id: userId // Add the user ID to the interaction
    });
  } catch (error) {
    console.error('Error logging agent interaction:', error);
  }
  
  // Assemble the full message with signature and key ID
  const fullMessage: A2AMessage = {
    id,
    timestamp,
    fromAgent: message.fromAgent,
    toAgent: message.toAgent,
    content: message.content,
    signature: signature,
    keyId: keyId,
    metadata: {
      protocol: 'A2A',
      version: '1.1',
      messageType: 'REQUEST',
      ...message.metadata
    }
  };
  
  // Publish the message to the bus
  messageBus.publish(fullMessage);
  return fullMessage;
}
